import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscription } from 'rxjs/internal/Subscription';
import { debounceTime, distinctUntilChanged, map, skipWhile } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { AppState, MyOrdersActionTypes } from '@app/core/ngrx';
import { ExcelService } from '../../services/excel.service';
import { HelperService } from '@app/core/services';

@Component({
  selector: 'ecp-my-orders-search',
  templateUrl: './my-orders-search.component.html',
  styleUrls: ['./my-orders-search.component.scss'],
})
export class MyOrdersSearchComponent implements OnInit, OnDestroy {
  @Input() myOrders: any[];
  private searchSub$: Subscription;
  public search$: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor(private store: Store<AppState>, private excelService: ExcelService, private helper: HelperService) {}
  ngOnInit(): void {
    this.searchSub$ = this.search$
      .pipe(
        skipWhile(event => !event),
        map(event => event.currentTarget.value),
        debounceTime(700),
        distinctUntilChanged(),
      )
      .subscribe(term => {
        this.store.dispatch({
          type: MyOrdersActionTypes.SEARCH_MY_ORDERS,
          payload: term,
        });
      });
  }

  ngOnDestroy(): void {
    if (this.searchSub$) this.searchSub$.unsubscribe();
  }

  searchDate(event): void {
    let date = new Date(event.value);
    let dayDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let monthDate = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let newDate = event.value ? date.getFullYear() + '-' + monthDate + '-' + dayDate : '';
    this.store.dispatch({
      type: MyOrdersActionTypes.SEARCH_MY_ORDERS,
      payload: newDate,
    });
  }

  exportAsXLSX(): void {
    const endDate = new Date();
    const endDateTime = endDate.getTime();
    const startDate = new Date(endDate.setDate(endDate.getDate() - 30));
    const startDateTime = startDate.getTime();

    const filteredOrders = this.myOrders.filter(x => {
      const elementDateTime = new Date(x.orderDate).getTime();
      if (elementDateTime <= endDateTime && elementDateTime > startDateTime) {
        return true;
      }
      return false;
    });

    let preparedOrderData = [];
    for (let i = 0; i < filteredOrders.length; i++) {
      let item = filteredOrders[i];
      let lineItems = item.lineItems[0];
      preparedOrderData.push({
        'Frame Order Number': item.orderNumber,
        UPC: lineItems.frame.upc,
        BRAND: lineItems.frame.brandName,
        Category: lineItems.frame.categoryName,
        Frame: lineItems.frame.styleName,
        'Patient Name': lineItems.patientName,
        'Order Date': this.convertDate(item.orderDate),
        Lab: item.dropship.name,
        'Frame Status': this.getFrameStatus(item).status,
        'Status Date': this.convertDate(item.statusDate),
        'Rx Order Number': item.sqlRXOrderNumber,
        'Rx Order Status': this.getRxStatus(item).status,
        'Rx Order Status Date': this.convertDate(item.sqlOrderStatusDate),
        'Ordered By': item.orderedBy,
      });
    }

    this.excelService.exportAsExcelFile(preparedOrderData, 'FD_Orders');
  }

  /**
   * getRxStatus
   * @param order
   */
  public getRxStatus(order) {
    return this.helper.getRxStatus(order);
  }

  /**
   * getRxStatus
   * @param order
   */
  public getFrameStatus(order) {
    return this.helper.getFrameStatus(order);
  }

  /**
   * getRxStatus
   * @param order
   */
  public convertDate(date) {
    return this.helper.convertToLocalDate(date);
  }
}
